// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, is, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

const outcomes = sharedConstants.PLACEMENTS.PREVIEW.OUTCOMES;
const bannerTypes = sharedConstants.PLACEMENTS.PREVIEW.BANNER_TYPES;
const loseReasons = sharedConstants.PLACEMENTS.PREVIEW.LOSE_REASONS;
const loseDetails = sharedConstants.PLACEMENTS.PREVIEW.LOSE_DETAILS;

const nullableString = anyOf(is(null), string);
const nullableNumber = anyOf(is(null), number);

const campaignSource = { type: is(bannerTypes.CAMPAIGN), canvas_id: is(null) };
const canvasStepSource = { type: is(bannerTypes.CANVAS_STEP), canvas_id: string };

const bannerFields = {
  campaign_base_id: string,
  name: string,
  priority: nullableNumber,
  variation_id: string,
  variation_name: nullableString,
  is_control: boolean,
  html: nullableString,
  preview_url_id: nullableString,
  failure_message: nullableString,
};

const bannerValidator = anyOf(
  objectOf({ ...bannerFields, ...campaignSource }),
  objectOf({ ...bannerFields, ...canvasStepSource })
);

const loserFields = {
  campaign_base_id: string,
  name: string,
  priority: nullableNumber,
  priority_bucket: anyOf(is(null), is("high"), is("medium"), is("low")),
  priority_position: nullableNumber,
  reason: anyOf(
    is(loseReasons.OUTRANKED),
    is(loseReasons.NOT_IN_AUDIENCE),
    is(loseReasons.NOT_RUNNING),
    is(loseReasons.OTHER_APP),
    is(loseReasons.DISMISSED)
  ),
  detail: anyOf(
    is(null),
    is(loseDetails.DRAFT),
    is(loseDetails.STOPPED),
    is(loseDetails.NOT_STARTED),
    is(loseDetails.ENDED),
    is(loseDetails.OUTSIDE_LOCAL_SCHEDULE),
    is(loseDetails.SEGMENT),
    is(loseDetails.NOT_AT_CANVAS_STEP),
    is(loseDetails.APP_NOT_TARGETED)
  ),
  detail_time: nullableNumber,
  rank: nullableNumber,
};

const loserValidator = anyOf(
  objectOf({ ...loserFields, ...campaignSource }),
  objectOf({ ...loserFields, ...canvasStepSource })
);

export const isGetAppGroupsAppGroupIdPlacementsIdPreviewResult = objectOf({
  placement: objectOf({ id: string, placement_id: string, name: string }),
  user: objectOf({ id: string, external_id: nullableString }),
  app: objectOf({ id: string, name: string }),
  evaluated_at: number,
  outcome: anyOf(
    is(outcomes.WINNER),
    is(outcomes.WINNER_HIDDEN),
    is(outcomes.NO_WINNER),
    is(outcomes.NO_CANDIDATES),
    is(outcomes.PLATFORM_UNSUPPORTED),
    is(outcomes.RENDER_ABORTED),
    is(outcomes.RENDER_ERROR)
  ),
  banner: anyOf(is(null), bannerValidator),
  eligible_count: number,
  losers: arrayOf(loserValidator),
  hidden_loser_count: number,
});
